export const getMonthName = (dateStr) => {
  const date = new Date(dateStr);
  const monthNames = [
    "January", "February", "March", "April",
    "May", "June", "July", "August",
    "September", "October", "November", "December"
  ];
  const monthIndex = date.getMonth();
  const monthName = monthNames[monthIndex];
  return monthName;
}